<script lang="ts">
	// Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';

	// Helpers
	import { real_id } from 'src/helpers/interface_helpers';

	// Components
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';

	// Types
	import type { Device } from 'src/types/Device.ts';
	import ControlSwitch from 'src/components/Controls/Single/ControlSwitch.svelte';

	export let device: Device;

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;
</script>

<DeviceViewStateWrapper {device}>
	<div class="flex-full-height align-items-center justify-content-center" slot="content">
		<ControlSwitch {device} {status} {settings} isWide />
	</div>
</DeviceViewStateWrapper>
